// deps
import React, { memo, useEffect } from "react";

// internal-deps
import { DialogHOC } from "@swiggy-private/core-ui";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { CloseIcon } from "@cart-ui/widgets/close-icon";

// constants
import { ADD_ADDRESS_CONFIGS } from "@cart-ui/constants/Address";

// styles
import { Container, StyledCloseIcon, StyledText } from "./styles";

export interface AddAddressPopupProps {
    closeModal: VoidFunction;
    onCtaClick: VoidFunction;
    onImpression?: VoidFunction;
}

const AddAddressPopup: React.FC<AddAddressPopupProps> = ({ closeModal, onCtaClick, onImpression }) => {
    useEffect(() => {
        onImpression?.();
    }, [onImpression]);

    return (
        <Container>
            <StyledCloseIcon>
                <CloseIcon
                    onClick={closeModal}
                    IconBgColor={ADD_ADDRESS_CONFIGS.CLOSE_ICON.color}
                    IconFillColor={ADD_ADDRESS_CONFIGS.CLOSE_ICON.fill}
                    size={ADD_ADDRESS_CONFIGS.CLOSE_ICON.size}
                />
            </StyledCloseIcon>
            <StyledText variant="V2.heading2.neutral.black" color="text_Highest_Emphasis">
                {ADD_ADDRESS_CONFIGS.TITLE}
            </StyledText>
            <SuperButton variant="fullwidth" buttonType="primary" buttonSize="medium" onClick={onCtaClick}>
                {ADD_ADDRESS_CONFIGS.CTA}
            </SuperButton>
        </Container>
    );
};

export default DialogHOC(memo(AddAddressPopup));
